<script>
import EntityEditor from '@/modules/entity/editor/EntityEditor';
import toast from '@/modules/toast/services';

export default {
  name: 'nx-profile-editor',
  extends: EntityEditor,
  methods: {
    async save() {
      this.loadingStart();
      try {
        if (this.$refs.form) {
          await this.$refs.form.validateAndShowErrors();
        }
        await this.dispatch('SAVE');
        toast.notify('message.entity.actions.savedSuccess');
      } catch (err) {
        console.error(err);
        toast.error('message.entity.actions.savedFailed');
      } finally {
        this.loadingFinish();
      }
    },
  },
};
</script>
